import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import authReducer from "./auth/auth.slice";

const reducers = combineReducers({
  auth: authReducer,
});

const persistConfig = {
  key: "root",
  storage,
  version: 14,
  whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

function PersistLoading() {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "system-ui, Segoe UI, sans-serif",
        color: "#5363FF",
      }}
    >
      Loading
    </div>
  );
}

export const StoreProvider = ({
  children,
}: {
  children: React.ReactElement;
}) => (
  <Provider store={store}>
    <PersistGate loading={<PersistLoading />} persistor={persistor}>
      {children}
    </PersistGate>
  </Provider>
);

export default StoreProvider;
